var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.509 23.0326C18.44 24.0689 17.2727 23.9053 16.149 23.4144C14.96 22.9125 13.869 22.8907 12.6145 23.4144C11.0436 24.0907 10.2145 23.8944 9.27632 23.0326C3.95268 17.5453 4.73814 9.18891 10.7818 8.88346C12.2545 8.95982 13.28 9.69073 14.1418 9.75619C15.429 9.49437 16.6618 8.74164 18.0363 8.83982C19.6836 8.97073 20.9272 9.62528 21.7454 10.8035C18.3418 12.8435 19.149 17.3271 22.269 18.5816C21.6472 20.218 20.84 21.8435 19.4981 23.0435L19.509 23.0326ZM14.0327 8.818C13.869 6.38528 15.8436 4.378 18.1127 4.18164C18.429 6.99619 15.56 9.09073 14.0327 8.818Z",
    fill: "#282B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplelogo);
export default __webpack_public_path__ + "static/media/apple logo.909bb0d8e34cf78667e4a3acee4bb857.svg";
export { ForwardRef as ReactComponent };